import { render, staticRenderFns } from "./CurateVectraits.vue?vue&type=template&id=b6ca0c44&scoped=true&"
import script from "./CurateVectraits.vue?vue&type=script&lang=js&"
export * from "./CurateVectraits.vue?vue&type=script&lang=js&"
import style0 from "./CurateVectraits.vue?vue&type=style&index=0&id=b6ca0c44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ca0c44",
  null
  
)

export default component.exports